import React, { Component } from 'react';
import './SaveJobPricingContainer.scss';
import SlideoutHeader from 'ps-components/Slideout/Header/SlideoutHeader';
import { hideSlideout, showSlideout } from 'ps-components/Slideout/SlideoutReducer';
import { array, bool, func, number, object, shape, string } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Alert, FormGroup, Input, InputNumber, TextArea, Tooltip } from 'ps-design';
import SkillsAndCertifications from 'ps-components/Modules/AddJob/SkillsAndCertifications';
import Dropdown from 'ps-components/Dropdown/Dropdown';
import SlideoutFooter from 'ps-components/Slideout/Footer/SlideoutFooter';
import SlideoutFooterStandardButtons from 'ps-components/Slideout/Footer/SlideoutFooterStandardButtons';
import ActionableHeaderCard from 'ps-components/Card/ActionableHeaderCard';
import classNames from 'classnames';
import Select from 'ps-components/ReactSelect/ReactSelect';
import { getJobFamilies, addJobFamilyOption } from 'ps-components/Modules/AddJob/reducers/jobFamilies';
import { getCareerLevels, addCareerLevelOption } from 'ps-components/Modules/AddJob/reducers/careerLevels';
import { getJobUserDefinedFields } from '../../JobMatching/OrgJobsActions';
import SelectableInput, { INPUT_TYPE } from 'ps-components/SelectableInput/SelectableInput';
import {
  getJobSkills,
  skillsSearch,
  resetSkillsByJobListReducer
} from 'ps-components/Modules/AddJob/reducers/skillsByJobList';
import {
  certificationsSearch,
  getJobCerts,
  resetJobCertificationsReducer
} from 'ps-components/Modules/AddJob/reducers/jobCertifications';
import * as saveJobPricingActionCreators from './SaveJobPricingActions';
import { getJobPricingDetails } from '../JobPricing/JobPricingActions';
import { jobPricingGridActions } from '../JobPricingDetails/JobPricingGrid/JobPricingGridCreate';
import { BASE_MARKET_TARGET_OPTIONS, FULL_MARKET_TARGET_OPTIONS } from './SaveJobPricingReducer';
import { SLIDEOUTS } from 'ps-components/Slideout/Slideouts';
import { withRouter } from 'react-router-dom';
import SlideoutSubmitSuccess from 'ps-components/Slideout/SubmitSuccess/SlideoutSubmitSuccess';
import { setSelectedJobId } from '../JobPricing/JobPricingActions';
import ProgressStatusOverlay from 'ps-components/ProgressStatus/ProgressStatusOverlay';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import { AllHtmlEntities } from 'html-entities';
import addAlert from 'ps-components/AlertToast/addAlert';
import StructuresAutoComplete from './StructuresAutoComplete/StructuresAutoComplete';
import { selectStructures, selectJobStructure } from './SaveJobPricingSelectors';
import { CONTACT_SUPPORT_MESSAGE } from '../../../lib/constants';
import { getColumnIndex } from 'ps-components/AdvancedTable/GenericGrid/GenericGridHelper';
import { formatCurrency, formatNumber } from 'ps-components/Utils/currencyUtils';
import { OverlayTrigger } from 'react-bootstrap/lib';
import ReactTooltip from 'react-tooltip';

class SaveJobPricingContainer extends Component {
  static propTypes = {
    actions: shape({
      hideSlideout: func,
      showSlideout: func,
      getSalaryRanges: func,
      setCurrency: func,
      setSalaryRange: func,
      getJobFamilies: func,
      getCareerLevels: func,
      setJobFamily: func,
      setCareerLevel: func,
      getJobUserDefinedFields: func,
      getJobSkills: func,
      skillsSearch: func,
      setJobTitle: func,
      getJobCerts: func,
      certificationsSearch: func,
      saveOrgJob: func,
      setOrgJobCode: func,
      setJobDescription: func,
      setYearsOfExperience: func,
      setTargetBaseSalary: func,
      setTargetTotalCash: func,
      setTargetTotalTargetCash: func,
      setTargetTotalGuaranteedPay: func,
      setTargetTotalDirect: func,
      setFLSAExempt: func,
      setEEOJobGroup: func,
      setEEOJobCategory: func,
      setSelectedJobId: func,
      resetSaveJobPricingToInitialState: func,
      setOrgJobCodeKey: func,
      setOrgJobDetails: func,
      initializeSaveJobPricingWithJob: func,
      setSelectedUserDefinedFields: func,
      resetSkillsByJobListReducer: func,
      resetJobCertificationsReducer: func,
      getJobPricingDetails: func
    }),
    currency: string,
    orgJobCode: string,
    currencies: array,
    currenciesLoaded: bool,
    salaryRanges: array,
    structures: array,
    jobStructure: object,
    salaryRange: object,
    isSalaryRangesLoading: bool,
    isSalaryRangesLoaded: bool,
    isJobFamiliesLoading: bool,
    isJobFamiliesLoaded: bool,
    jobFamilies: array,
    jobDescription: string,
    careerLevels: array,
    isCareerLevelsLoading: bool,
    isCareerLevelsLoaded: bool,
    jobFamily: string,
    careerLevel: string,
    defaultCurrency: string,
    userDefinedFields: array,
    isUserDefinedFieldsLoading: bool,
    isUserDefinedFieldsLoaded: bool,
    skillsByJobList: shape({
      loading: bool,
      loaded: bool,
      skillsSearchItems: array,
      allSkills: array
    }),
    jobCertifications: shape({
      loading: bool,
      loaded: bool,
      certsSearchItems: array,
      allCerts: array
    }),
    jobTitle: string,
    yearsOfExperience: string,
    targetTotalCash: string,
    targetBaseSalary: string,
    targetTotalTargetCash: string,
    targetTotalGuaranteedPay: string,
    targetTotalDirect: string,
    isSaving: bool,
    isSaveFailed: bool,
    isSaved: bool,
    organization: object,
    replacementTokens: array,
    history: object,
    orgJobId: number,
    slideout: object,
    orgJobCodeKey: string,
    eeoJobCategory: string,
    eeoJobGroup: string,
    flsaExempt: string,
    orgJobDetails: object,
    hasErrorRetrievingFields: bool,
    isDuplicateError: bool,
    agingCode: string,
    currentJob: shape({
      id: number,
      code: string,
      codeKey: string
    }).isRequired,
    selectedUserDefinedFields: array,
    isInitialized: bool,
    match: object,
    onSave: func,
    isReadOnly: bool,
    isSlotted: bool,
    salaryRangeMin: string,
    salaryRangeMid: string,
    salaryRangeMax: string,
    uniqueSalaryRange: bool,
    jobPricingGrid: object,
    pricingDataLoading: bool,
    displayIn: string
  };

  constructor(props) {
    super(props);

    this.htmlEntities = new AllHtmlEntities();
    // scrollRef used to scroll up when opening slideout
    this.scrollRef = React.createRef();

    this.state = { 
      isJobDataFormCollapsed: true, 
      jobDataFormHeight: 0, 
      selectedStructure: null,
      recommendedGrade: null,
      recommendedGradeInfo: null
    };
    this.jobDataFormRef = React.createRef();
    this.hideSlideout = this.hideSlideout.bind(this);
    this.saveOrgJob = this.saveOrgJob.bind(this);
    this.handleSlideoutSuccessAction = this.handleSlideoutSuccessAction.bind(this);
    this.retrieveJobSkillsAndCerts = this.retrieveJobSkillsAndCerts.bind(this);
    this.handleJobFormCollapseOnClick = this.handleJobFormCollapseOnClick.bind(this);
    this.handleJobTitleOnChange = this.handleJobTitleOnChange.bind(this);
    this.handleCurrencyOnChange = this.handleCurrencyOnChange.bind(this);
    this.handleOrgJobCodeOnChange = this.handleOrgJobCodeOnChange.bind(this);
    this.handleOrgJobCodeKeyOnChange = this.handleOrgJobCodeKeyOnChange.bind(this);
    this.handleJobFamilyOnChange = this.handleJobFamilyOnChange.bind(this);
    this.handleCareerLevelOnChange = this.handleCareerLevelOnChange.bind(this);
    this.handleEEOJobCategoryOnChange = this.handleEEOJobCategoryOnChange.bind(this);
    this.handleFLSAExemptOnChange = this.handleFLSAExemptOnChange.bind(this);
    this.handleEEOJobGroupOnChange = this.handleEEOJobGroupOnChange.bind(this);
    this.handleYearsOfExperienceOnChange = this.handleYearsOfExperienceOnChange.bind(this);
    this.handleJobDescriptionOnChange = this.handleJobDescriptionOnChange.bind(this);
    this.handleSelectableInputOnChange = this.handleSelectableInputOnChange.bind(this);
    this.handleSkillAndCertificationsUpdate = this.handleSkillAndCertificationsUpdate.bind(this);
    this.formatOptions = this.formatOptions.bind(this);
    this.handleSalaryRangeMin = this.handleSalaryRangeMin.bind(this);
    this.handleSalaryRangeMid = this.handleSalaryRangeMid.bind(this);
    this.handleSalaryRangeMax = this.handleSalaryRangeMax.bind(this);
    this.handleStructureOnChange = this.handleStructureOnChange.bind(this);
    this.findRecommendedGrade = this.findRecommendedGrade.bind(this);
    this.extractCompositePricingData = this.extractCompositePricingData.bind(this);
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {
    const { actions } = this.props;
    this.resetReducers();
  }

  componentDidUpdate(prevProps, prevState) {
    const { slideout, jobTitle } = this.props;
    if (this.jobDataFormRef.current && this.getJobDataFormHeight() !== this.state.jobDataFormHeight) {
      this.setState({ jobDataFormHeight: this.getJobDataFormHeight() });
    }

    if (!prevProps.slideout.open && slideout.open) {
      if (this.scrollRef?.current?.scrollTop) {
        this.scrollRef.current.scrollTop = 0;
      }
      this.init();
    }

    if (prevProps.slideout.open && !slideout.open) {
      this.resetReducers();
      this.setState({ 
        selectedStructure: null,
        recommendedGrade: null,
        recommendedGradeInfo: null
      });
    }

    if (slideout.open && prevProps.jobTitle !== jobTitle) {
      this.debouncedRetrieveJobSkillsAndCerts();
    }
  }

  init() {
    const { actions, currentJob, defaultCurrency } = this.props;
    actions.initializeSaveJobPricingWithJob(currentJob);
    this.setState({
      jobDataFormHeight: this.getJobDataFormHeight(),
      hasDefaultCurrency: !!defaultCurrency
    });
    actions.setCurrency(defaultCurrency);

    this.initDropdownOptions(defaultCurrency);
    actions.getJobUserDefinedFields();
  }

  resetReducers() {
    const { actions } = this.props;
    actions.resetSaveJobPricingToInitialState();
    actions.resetSkillsByJobListReducer();
    actions.resetJobCertificationsReducer();
  }

  initDropdownOptions(currencyCode) {
    const { actions } = this.props;
    actions.getSalaryRanges(currencyCode);
    actions.getJobFamilies(currencyCode);
    actions.getCareerLevels(currencyCode);
  }

  getJobDataFormHeight() {
    if (this.jobDataFormRef.current) {
      return this.jobDataFormRef.current.offsetHeight;
    }
    return 0;
  }

  formatOptions(options, value) {
    const newOptions = options;

    // make sure an empty option exists at top of list
    if (newOptions[0]?.value !== '') {
      newOptions.unshift({ value: '', label: '' });
    }

    // if the saved value doesn't exist, add to the list
    if (!options.find(op => op.value === value)) {
      newOptions.push({ value, label: value });
    }

    return newOptions;
  }

  render() {
    const {
      jobTitle,
      orgJobCode,
      currency,
      salaryRange,
      isSaving,
      isSaveFailed,
      isSaved,
      hasErrorRetrievingFields,
      isDuplicateError,
      isReadOnly,
      uniqueSalaryRange
    } = this.props;
    const isAdHocJob = this.isAdHocJob();

    const saveDisabled =
      !jobTitle ||
      !orgJobCode ||
      !currency ||
      isSaving ||
      (!uniqueSalaryRange && !salaryRange) ||
      hasErrorRetrievingFields ||
      isReadOnly;

    return (
      <React.Fragment>
        {!isSaved && (
          <React.Fragment>
            <ProgressStatusOverlay
              inProgress={isSaving}
              primaryText={isAdHocJob ? 'Saving Ad Hoc Pricing...' : 'Saving Job Details...'}
              submitSuccessDetails="This might take a moment"
            />
            {(isSaveFailed || hasErrorRetrievingFields) && (
              <div className="alert__container">
                <Alert
                  message={
                    <React.Fragment>
                      <h4>{this.getSaveOrgJobErrorMessage()}</h4>
                      {!isDuplicateError && (
                        <div className="save-job-pricing-failure__text">
                          {CONTACT_SUPPORT_MESSAGE}
                        </div>
                      )}
                    </React.Fragment>
                  }
                />
              </div>
            )}
            <div className="save-job-pricing__container" ref={this.scrollRef}>
              <SlideoutHeader title={isAdHocJob ? 'Save this Pricing' : 'Edit Job'} doClose={this.hideSlideout} />
              {this.renderJobDataForm()}
              {this.renderJobDescriptionForm()}
              {this.renderMarketTargetForm()}
              {this.renderUserDefinedFields()}
            </div>
            <SlideoutFooter isBoxShadowTheme={true}>
              <SlideoutFooterStandardButtons
                applyText="Save"
                doCancel={this.hideSlideout}
                doApply={this.saveOrgJob}
                isApplyDisabled={saveDisabled}
              />
            </SlideoutFooter>
          </React.Fragment>
        )}
        {isSaved && (
          <div className="save-job-pricing-saved__container">
            <SlideoutSubmitSuccess
              actionText="Done"
              submitSuccessDetails={isAdHocJob ? 'A new job has been created based on this pricing.' : ''}
              submitSuccessTitle={isAdHocJob ? 'Ad hoc pricing has been saved!' : 'Job details have been saved!'}
              closeAction={this.hideSlideout}
              actionFunction={this.hideSlideout}
            />
          </div>
        )}
      </React.Fragment>
    );
  }

  getSaveOrgJobErrorMessage() {
    const {
      isSaveFailed,
      isDuplicateError,
      orgJobCode,
      orgJobCodeKey,
      organization,
      currency,
      hasErrorRetrievingFields,
      replacementTokens
    } = this.props;

    const isAdHocJob = this.isAdHocJob();

    if (isSaveFailed) {
      let error = isAdHocJob ? 'Failed to save the ad hoc pricing. ' : 'Failed to save job details. ';
      if (isDuplicateError) {
        error += `A job already exists with Job Code: "${orgJobCode}", `;
        if (organization.useJobCodeKey) {
          const jobCodeKeyLabel = replacementTokens.find(replacement => replacement.token === 'job_code_key_text')
            .value;
          error += `${jobCodeKeyLabel}: "${orgJobCodeKey}", `;
        }
        error += `Currency: "${currency}"`;
      } else {
        error += 'Please try again later.';
      }
      return error;
    } else if (hasErrorRetrievingFields) {
      return 'Failed to retrieve job fields. Please try again later.';
    }
  }

  saveOrgJob() {
    const {
      actions,
      jobTitle,
      orgJobCode,
      orgJobId,
      orgJobCodeKey,
      currency,
      salaryRange,
      jobDescription,
      yearsOfExperience,
      orgJobDetails,
      targetTotalCash,
      targetBaseSalary,
      targetTotalTargetCash,
      targetTotalGuaranteedPay,
      targetTotalDirect,
      selectedUserDefinedFields,
      flsaExempt,
      eeoJobGroup,
      eeoJobCategory,
      jobFamily,
      careerLevel,
      agingCode,
      onSave,
      isSlotted,
      uniqueSalaryRange,
      salaryRangeMin,
      salaryRangeMid,
      salaryRangeMax
    } = this.props;

    const isAdHocJob = this.isAdHocJob();

    actions
      .saveOrgJob(
        isAdHocJob ? null : orgJobId,
        jobTitle,
        orgJobCode,
        orgJobCodeKey,
        currency,
        uniqueSalaryRange ? orgJobCode : salaryRange?.value || null,
        uniqueSalaryRange ? ' ' : salaryRange?.grade || null,
        jobDescription,
        yearsOfExperience,
        orgJobDetails?.jobDetails?.Skills || [],
        orgJobDetails?.jobDetails?.Certifications || [],
        targetTotalCash,
        targetBaseSalary,
        targetTotalTargetCash,
        targetTotalGuaranteedPay,
        targetTotalDirect,
        flsaExempt,
        eeoJobGroup,
        eeoJobCategory,
        jobFamily ?? '',
        careerLevel ?? '',
        selectedUserDefinedFields,
        agingCode,
        isSlotted,
        salaryRangeMin,
        salaryRangeMid,
        salaryRangeMax
      )
      .then(response => {
        if (response) {
          const { id, showGroupFilterMessage } = response;

          if (showGroupFilterMessage) {
            addAlert(
              'Job has been saved to your site but does not meet necessary group filtering requirements. Please contact your site administrator for more information.',
              'warning',
              'manual'
            );
          }

          if (id && onSave) {
            onSave(id, isSlotted, showGroupFilterMessage);
          }
        }
      });
  }

  isAdHocJob() {
    const { match } = this.props;
    return match.params.jobId === 'adhoc';
  }

  handleSlideoutSuccessAction() {
    const { history, orgJobId } = this.props;
    history.push({
      pathname: '/iframe/merit/hris/job/jobs',
      search: `?initial_job_id=${orgJobId}`
    });
    this.hideSlideout();
  }

  hideSlideout() {
    const { actions } = this.props;
    actions.resetSaveJobPricingToInitialState();
    actions.hideSlideout();
    this.setState({ showDefaultCurrency: false });
  }

  renderJobDataForm() {
    const {
      currencies,
      currenciesLoaded,
      actions,
      currency,
      salaryRange,
      structures,
      isSalaryRangesLoading,
      jobFamilies,
      isJobFamiliesLoading,
      careerLevels,
      isCareerLevelsLoading,
      jobFamily,
      careerLevel,
      jobTitle,
      organization,
      replacementTokens,
      orgJobCode,
      orgJobCodeKey,
      eeoJobCategory,
      eeoJobGroup,
      flsaExempt,
      isReadOnly,
      salaryRangeMin,
      salaryRangeMid,
      salaryRangeMax,
      uniqueSalaryRange,
      pricingDataLoading
    } = this.props;
    const { isJobDataFormCollapsed, jobDataFormHeight, selectedStructure, recommendedGradeInfo } = this.state;
    const structureValue = this.getStructureValue();
    const jobDataFormClassNames = classNames('job-data__form', {
      expanded: !isJobDataFormCollapsed,
      collapsed: isJobDataFormCollapsed
    });

    const salaryRangeLabel = replacementTokens.find(replacement => replacement.token === 'mrr_text').value;
    const salaryGradeLabel = replacementTokens.find(replacement => replacement.token === 'salary_grade_text').value;
    const careerLevelLabel = replacementTokens.find(replacement => replacement.token === 'career_level_text').value;
    const jobFamilyLabel = replacementTokens.find(replacement => replacement.token === 'job_org_unit_text').value;
    const jobCodeKeyLabel = replacementTokens.find(replacement => replacement.token === 'job_code_key_text').value;

    const renderCompositePricingData = () => { 
      const compositePricingData = this.extractCompositePricingData();
      if (!compositePricingData || !compositePricingData.baseSalary50th || pricingDataLoading) {
        return null;
      }

      return (
        <div className="composite-pricing-data">
          <h3 className="pxl-text-body">Market Pricing Data</h3>
          <div className="composite-pricing-data__content">
            {compositePricingData.baseSalary25th && (
              <div className="composite-pricing-data__row">
                <div className="composite-pricing-data__label">Base Salary 25th:</div>
                <div className="composite-pricing-data__value">
                  {formatCurrency(compositePricingData.baseSalary25th, compositePricingData.currency, 0)}
                </div>
              </div>
            )}
            <div className="composite-pricing-data__row">
              <div className="composite-pricing-data__label">Base Salary 50th:</div>
              <div className="composite-pricing-data__value">
                {formatCurrency(compositePricingData.baseSalary50th, compositePricingData.currency, 0)}
              </div>
            </div>

            {compositePricingData.baseSalary75th && (
              <div className="composite-pricing-data__row">
                <div className="composite-pricing-data__label">Base Salary 75th:</div>
                <div className="composite-pricing-data__value">
                  {formatCurrency(compositePricingData.baseSalary75th, compositePricingData.currency, 0)}
                </div>
              </div>
            )}
            {compositePricingData.baseSalaryAvg && (
              <div className="composite-pricing-data__row">
                <div className="composite-pricing-data__label">Base Salary Avg:</div>
                <div className="composite-pricing-data__value">
                  {formatCurrency(compositePricingData.baseSalaryAvg, compositePricingData.currency, 0)}
                </div>
              </div>
            )}
          </div>

          {recommendedGradeInfo && (
            <div className="recommended-grade">
              <div className="recommended-grade__header">
                <h3 className="pxl-text-body">Recommended Grade</h3>
                <div className="icon-reverse icon-circle">
                  <i className="icon-info" data-tip="The recommended grade is calculated by finding the grade where the market 50th percentile best fits within the grade's range. Formula: fitScore = (market50th - gradeMidpoint) / (rangeSize / 2)" data-for="recommended-grade-tooltip" />
                </div>
                <ReactTooltip id="recommended-grade-tooltip" place="top" multiline={true} />
              </div>
              <div className="recommended-grade__content">
                <div className="recommended-grade__row">
                  <div className="recommended-grade__label">Grade:</div>
                  <div className="recommended-grade__value recommended-grade__value--highlight">
                    {recommendedGradeInfo.grade}
                  </div>
                </div>
                <div className="recommended-grade__row">
                  <div className="recommended-grade__label">Range Min:</div>
                  <div className="recommended-grade__value">
                    {formatCurrency(recommendedGradeInfo.min, compositePricingData.currency, 0)}
                  </div>
                </div>
                <div className="recommended-grade__row">
                  <div className="recommended-grade__label">Range Mid:</div>
                  <div className="recommended-grade__value">
                    {formatCurrency(recommendedGradeInfo.mid, compositePricingData.currency, 0)}
                  </div>
                </div>
                <div className="recommended-grade__row">
                  <div className="recommended-grade__label">Range Max:</div>
                  <div className="recommended-grade__value">
                    {formatCurrency(recommendedGradeInfo.max, compositePricingData.currency, 0)}
                  </div>
                </div>
                {!recommendedGradeInfo.isOutOfRange && (
                  <div className="recommended-grade__row">
                    <div className="recommended-grade__label">% of Range:</div>
                    <div className="recommended-grade__value">
                      {recommendedGradeInfo.percentOfRange.toFixed(1)}%
                    </div>
                  </div>
                )}
                <div className="recommended-grade__row">
                  <div className="recommended-grade__label">% from Midpoint:</div>
                  <div className="recommended-grade__value">
                    {recommendedGradeInfo.percentFromMidpoint > 0 ? '+' : ''}
                    {recommendedGradeInfo.percentFromMidpoint.toFixed(1)}%
                  </div>
                </div>
                {recommendedGradeInfo.isOutOfRange && (
                  <div className="recommended-grade__warning">
                    <i className="icon-attention-alt"></i> The market base 50th for this job is outside of this grade's range.
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      );
    };

    // Custom styles for the recommended grade option
    const customStyles = {
      option: (provided, state) => {
        const isRecommended = recommendedGradeInfo && selectedStructure && 
          selectedStructure.value === recommendedGradeInfo.structure &&
          state.data.grade === recommendedGradeInfo.grade;

        return{
          ...provided,
          position: 'relative',
          backgroundColor: state.isSelected 
            ? provided.backgroundColor 
            : isRecommended 
              ? '#f0f7ff' 
              : provided.backgroundColor,
          '&:after': isRecommended
            ? {
                content: '"recommended"',
                position: 'absolute',
                right: '10px',
                top: '5px',
                fontSize: '0.7em',
                color: '#0066cc',
                fontStyle: 'italic'
              } 
            : {}
        }
      }
    };

    const formatGradeOptionLabel = (option) => {
      const isRecommended = recommendedGradeInfo && 
        selectedStructure && 
        selectedStructure.value === recommendedGradeInfo.structure &&
        option.grade === recommendedGradeInfo.grade;
      
      const salaryMinimum = option.min ? Math.trunc(option.min) : (option.salaryMinimum ? Math.trunc(option.salaryMinimum) : null);
      const salaryMidpoint = option.mid ? Math.trunc(option.mid) : (option.salaryMidpoint ? Math.trunc(option.salaryMidpoint) : null);
      const salaryMaximum = option.max ? Math.trunc(option.max) : (option.salaryMaximum ? Math.trunc(option.salaryMaximum) : null);
      
      const rangeParts = [];
      if (salaryMinimum) rangeParts.push(`Min: ${salaryMinimum.toLocaleString()}`);
      if (salaryMidpoint) rangeParts.push(`Mid: ${salaryMidpoint.toLocaleString()}`);
      if (salaryMaximum) rangeParts.push(`Max: ${salaryMaximum.toLocaleString()}`);
      
      return (
        <div className={`grade-option ${isRecommended ? 'grade-option--recommended' : ''}`}>
          <div className="grade-option__name">{option.name || option.value} {option.grade}</div>
          <div className="grade-option__range">
            {rangeParts.map((part, index) => (
              <React.Fragment key={index}>
                {part}
                {index < rangeParts.length - 1 && <span style={{ marginRight: '10px' }}></span>}
              </React.Fragment>
            ))}
          </div>
        </div>
      );
    };

    const formatGradeValueLabel = (option) => {
      return `${option.name || option.value} ${option.grade}`;
    };

    return (
      <ActionableHeaderCard
        cardTitle="Job Data"
        className="save-job-pricing__card"
        isCollapsible={true}
        templateRef={this.jobDataFormRef}
      >
        <div className={jobDataFormClassNames} style={{ height: this.state.jobDataFormHeight }}>
          <div ref={this.jobDataFormRef}>
            <div className="row">
              <div className="col-md-6">
                <FormGroup>
                  {this.getFormGroupLabelForRequiredField('Job Title')}
                  <Input onChange={this.handleJobTitleOnChange} value={jobTitle} disabled={isReadOnly} />
                </FormGroup>
              </div>
              {currencies && (
                <div className="col-md-6">
                  <FormGroup>
                    {this.getFormGroupLabelForRequiredField('Currency')}
                    <Select
                      options={this.getCurrencyOptions()}
                      value={currencies.find(curr => curr.code === currency)}
                      getOptionLabel={option => option.name}
                      getOptionValue={option => option.code}
                      onChange={this.handleCurrencyOnChange}
                      isDisabled={!currenciesLoaded || this.state.hasDefaultCurrency === true || isReadOnly}
                      instanceId="job-currency-select"
                    />
                  </FormGroup>
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-md-6">
                <FormGroup>
                  {this.getFormGroupLabelForRequiredField('Job Code')}
                  <Input onChange={this.handleOrgJobCodeOnChange} value={orgJobCode} disabled={isReadOnly} />
                </FormGroup>
              </div>
              {organization.useJobCodeKey && (
                <div className="col-md-6">
                  <FormGroup text={jobCodeKeyLabel} labelClassName="form-control__label">
                    <Input onChange={this.handleOrgJobCodeKeyOnChange} value={orgJobCodeKey} disabled={isReadOnly} />
                  </FormGroup>
                </div>
              )}
            </div>
            {!uniqueSalaryRange ? (
              <div className="row">
                <div className="col-md-6">
                  <FormGroup>
                    {this.getFormGroupLabelForRequiredField(salaryRangeLabel)}
                    {structures?.length < 2000 ? (
                      <Select
                        placeholder={'Select...'}
                        options={structures}
                        value={structureValue}
                        getOptionLabel={option => option.label}
                        getOptionValue={option => option.value}
                        onChange={this.handleStructureOnChange}
                        instanceId="salary-range-select"
                        isDisabled={!currency || isSalaryRangesLoading || isReadOnly}
                      />
                    ) : (
                      <StructuresAutoComplete
                        structures={structures}
                        value={structureValue?.label}
                        onSelectionChange={this.handleStructureOnChange}
                        onInputChange={() => {
                          if (this.state.selectedStructure) {
                            this.setState({ selectedStructure: null }, () => {
                              this.findRecommendedGrade();
                            });
                            actions.setSalaryRange(null);
                          }
                        }}
                        salaryRangeLabel={salaryRangeLabel}
                        disabled={!currency || isSalaryRangesLoading || isReadOnly}
                      />
                    )}
                  </FormGroup>
                </div>
                {structureValue && (
                  <div className="col-md-6">
                    <FormGroup>
                      {this.getFormGroupLabelForRequiredField(salaryGradeLabel)}
                      <Select
                        options={structureValue.ranges ? structureValue.ranges.sort((a, b) => a.salaryMidpoint - b.salaryMidpoint) : []}
                        value={salaryRange}
                        onChange={range => {
                          actions.setSalaryRange(range);
                        }}
                        getOptionLabel={formatGradeOptionLabel}
                        getOptionValue={option => option.grade}
                        formatOptionLabel={(option, { context }) => 
                          context === 'value' ? formatGradeValueLabel(option) : formatGradeOptionLabel(option)
                        }
                        styles={customStyles}
                        className="grade-select"
                      />
                    </FormGroup>
                  </div>
                )}
              </div>
            ) : null}
            {uniqueSalaryRange ? (
              <div className="row">
                <span className="pay-range__title">
                  <label className="form-control__label pxl-control-label">Salary Range</label>
                </span>
                <div className="col-md-12">
                  <FormGroup text={'Min'} className="col-md-4 pay-range__input" labelClassName="form-control__label">
                    <InputNumber min={0} onChange={this.handleSalaryRangeMin} value={salaryRangeMin} />
                  </FormGroup>
                  <FormGroup text={'Mid'} className="col-md-4 pay-range__input" labelClassName="form-control__label">
                    <InputNumber min={0} onChange={this.handleSalaryRangeMid} value={salaryRangeMid} />
                  </FormGroup>
                  <FormGroup text={'Max'} className="col-md-4 pay-range__input" labelClassName="form-control__label">
                    <InputNumber min={0} onChange={this.handleSalaryRangeMax} value={salaryRangeMax} />
                  </FormGroup>
                </div>
              </div>
            ) : null}
            {!isJobDataFormCollapsed && (
              <React.Fragment>
                <div className="row border-gap" />
                <div className="row">
                  <div className="col-md-6">
                    <FormGroup text={jobFamilyLabel} labelClassName="form-control__label">
                      <Select
                        options={this.formatOptions(jobFamilies, jobFamily)}
                        value={jobFamily && jobFamilies.find(family => family.value === jobFamily)}
                        onChange={this.handleJobFamilyOnChange}
                        instanceId="job-families-select"
                        isDisabled={isJobFamiliesLoading || isReadOnly}
                        isCreatable
                      />
                    </FormGroup>
                  </div>
                  <div className="col-md-6">
                    <FormGroup text={careerLevelLabel} labelClassName="form-control__label">
                      <Select
                        options={this.formatOptions(careerLevels, careerLevel)}
                        value={careerLevel && careerLevels.find(level => level.value === careerLevel)}
                        onChange={this.handleCareerLevelOnChange}
                        instanceId="career-levels-select"
                        isDisabled={isCareerLevelsLoading || isReadOnly}
                        isCreatable
                      />
                    </FormGroup>
                  </div>
                </div>
                {currency === 'USD' && (
                  <React.Fragment>
                    <div className="row">
                      <div className="col-md-6">
                        <FormGroup text="EEO Job Category" labelClassName="form-control__label">
                          <Input
                            onChange={this.handleEEOJobCategoryOnChange}
                            maxLength={50}
                            value={eeoJobCategory}
                            disabled={isReadOnly}
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-6">
                        <FormGroup text="FLSA Exempt" labelClassName="form-control__label">
                          <Input
                            onChange={this.handleFLSAExemptOnChange}
                            maxLength={40}
                            value={flsaExempt}
                            disabled={isReadOnly}
                          />
                        </FormGroup>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <FormGroup text="EEO Job Group" labelClassName="form-control__label">
                          <Input
                            onChange={this.handleEEOJobGroupOnChange}
                            maxLength={50}
                            value={eeoJobGroup}
                            disabled={isReadOnly}
                          />
                        </FormGroup>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
            <div className="row">
              <div className="col-md-12">
                <div className="collapse__link">
                  <a onClick={this.handleJobFormCollapseOnClick}>
                    {isJobDataFormCollapsed ? 'Show More' : 'Show Less'}
                  </a>
                </div>
              </div>
            </div>
            {this.isAdHocJob() && renderCompositePricingData()}
          </div>
        </div>
      </ActionableHeaderCard>
    );
  }

  getCurrencyOptions() {
    const { currencies, currency } = this.props;
    return currencies.filter(curr => {
      if (this.state.hasDefaultCurrency && currency) {
        return curr.code === currency;
      }
      return curr.code !== '%';
    });
  }

  handleJobTitleOnChange(id, jobTitle) {
    const { actions } = this.props;
    actions.setJobTitle(jobTitle);
  }

  handleSalaryRangeMin(id, rangeMin) {
    const { actions } = this.props;
    actions.setSalaryRangeMin(rangeMin);
  }

  handleSalaryRangeMid(id, rangeMid) {
    const { actions } = this.props;
    actions.setSalaryRangeMid(rangeMid);
  }

  handleSalaryRangeMax(id, rangeMax) {
    const { actions } = this.props;
    actions.setSalaryRangeMax(rangeMax);
  }

  handleCurrencyOnChange(currencyOption) {
    const { actions } = this.props;
    actions.setCurrency(currencyOption.code);
    this.initDropdownOptions(currencyOption.code);
    actions.setSalaryRange(null);
    this.setState({ selectedStructure: null });
  }

  handleOrgJobCodeOnChange(id, orgJobCode) {
    const { actions } = this.props;
    actions.setOrgJobCode(orgJobCode);
  }

  handleOrgJobCodeKeyOnChange(id, orgJobCodeKey) {
    const { actions } = this.props;
    actions.setOrgJobCodeKey(orgJobCodeKey);
  }

  retrieveJobSkillsAndCerts() {
    const { actions, jobTitle, isReadOnly } = this.props;
    if (!isReadOnly) {
      actions.getJobSkills({ params: { title: jobTitle } });
      actions.getJobCerts({ params: { title: jobTitle } });
    }
  }

  debouncedRetrieveJobSkillsAndCerts = debounce(this.retrieveJobSkillsAndCerts, 750);

  handleJobFormCollapseOnClick() {
    const { isJobDataFormCollapsed } = this.state;
    this.setState({ isJobDataFormCollapsed: !isJobDataFormCollapsed });
  }

  handleJobFamilyOnChange(jobFamilyOption) {
    const { actions } = this.props;

    if (jobFamilyOption.__isNew__) {
      actions.addJobFamilyOption(jobFamilyOption.label, jobFamilyOption.value);
    }

    actions.setJobFamily(jobFamilyOption.value);
  }

  handleCareerLevelOnChange(careerLevelOption) {
    const { actions } = this.props;

    if (careerLevelOption.__isNew__) {
      actions.addCareerLevelOption(careerLevelOption.label, careerLevelOption.value);
    }

    actions.setCareerLevel(careerLevelOption.value);
  }

  handleEEOJobCategoryOnChange(id, eeoJobCategory) {
    const { actions } = this.props;
    actions.setEEOJobCategory(eeoJobCategory);
  }

  handleFLSAExemptOnChange(id, flsaExempt) {
    const { actions } = this.props;
    actions.setFLSAExempt(flsaExempt);
  }

  handleEEOJobGroupOnChange(id, eeoJobGroup) {
    const { actions } = this.props;
    actions.setEEOJobGroup(eeoJobGroup);
  }

  handleStructureOnChange(selectedStructure) {
    const { salaryRange, actions } = this.props;
    this.setState({ selectedStructure }, () => {
      this.findRecommendedGrade();
    });
    if (salaryRange) actions.setSalaryRange(null);
  }

  getStructureValue() {
    return this.state.selectedStructure || this.props.jobStructure;
  }

  renderJobDescriptionForm() {
    const {
      skillsByJobList,
      jobCertifications,
      actions,
      yearsOfExperience,
      orgJobDetails,
      jobDescription,
      isReadOnly
    } = this.props;
    const isMP = window?.app?.basicProductName === 'MarketPay';
    return (
      <ActionableHeaderCard cardTitle="Job Description" className="save-job-pricing__card" isCollapsible={true}>
        <div className="row">
          <div className="col-md-12">
            <FormGroup text="Years of Experience" className="row" labelClassName="col-xs-12">
              <div className="col-xs-3">
                <InputNumber
                  onChange={this.handleYearsOfExperienceOnChange}
                  onKeyDown={this.handleYearsOfExperienceKeyDown}
                  value={yearsOfExperience}
                  min={0}
                  disabled={isReadOnly}
                />
              </div>
            </FormGroup>
          </div>
        </div>
        <SkillsAndCertifications
          addJob={orgJobDetails}
          skillsByJobList={skillsByJobList}
          skillsSearch={actions.skillsSearch}
          saveJobAndUpdatePay={this.handleSkillAndCertificationsUpdate}
          jobCertifications={jobCertifications}
          certificationsSearch={actions.certificationsSearch}
          disabled={isReadOnly}
          isMP={isMP}
        />
        <div className="row">
          <div className="col-md-12">
            <FormGroup text="Job Summary" className="row" labelClassName="col-xs-12">
              <div className="col-xs-12">
                <TextArea
                  className="job-summary-textarea__container"
                  value={this.htmlEntities.decode(jobDescription)}
                  onChange={this.handleJobDescriptionOnChange}
                  rows={7}
                  disabled={isReadOnly}
                />
              </div>
            </FormGroup>
          </div>
        </div>
      </ActionableHeaderCard>
    );
  }

  handleYearsOfExperienceKeyDown(e) {
    if (e.key === 'e' || e.key === '-') {
      e.preventDefault();
    }
  }

  handleYearsOfExperienceOnChange(id, yearsOfExperience) {
    const { actions } = this.props;
    if (yearsOfExperience >= 0) {
      actions.setYearsOfExperience(yearsOfExperience);
    }
  }

  handleJobDescriptionOnChange(id, jobDescription) {
    const { actions } = this.props;
    actions.setJobDescription(this.htmlEntities.decode(jobDescription));
  }

  handleSkillAndCertificationsUpdate(job) {
    const { actions, orgJobDetails } = this.props;
    if (job.jobDetails) {
      if (job.jobDetails.Skills) {
        orgJobDetails.jobDetails.Skills = job.jobDetails.Skills;
        orgJobDetails.jobDetails.SkillNameList = job.jobDetails.SkillNameList;
      }
      if (job.jobDetails.Certifications) {
        orgJobDetails.jobDetails.Certifications = job.jobDetails.Certifications;
        orgJobDetails.jobDetails.CertNameList = job.jobDetails.CertNameList;
      }
    }
    actions.setOrgJobDetails(orgJobDetails);
  }

  renderMarketTargetForm() {
    const {
      targetTotalCash,
      targetBaseSalary,
      targetTotalTargetCash,
      targetTotalGuaranteedPay,
      targetTotalDirect,
      actions,
      isReadOnly
    } = this.props;
    return (
      <ActionableHeaderCard cardTitle="Market Target" className="save-job-pricing__card" isCollapsible={true}>
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <FormGroup text="Base Salary" className="col-xs-4" labelClassName="form-control__label">
                <Dropdown
                  dropdownItems={FULL_MARKET_TARGET_OPTIONS}
                  text={targetBaseSalary}
                  btnClass="btn-default"
                  className="save-pricing__dropdown"
                  dropdownClass="save-pricing__dropdown-items"
                  itemOnClick={actions.setTargetBaseSalary}
                  disabled={isReadOnly}
                />
              </FormGroup>
              <FormGroup text="Total Cash" className="col-xs-4" labelClassName="form-control__label">
                <Dropdown
                  dropdownItems={FULL_MARKET_TARGET_OPTIONS}
                  text={targetTotalCash}
                  btnClass="btn-default"
                  className="save-pricing__dropdown"
                  dropdownClass="save-pricing__dropdown-items"
                  itemOnClick={actions.setTargetTotalCash}
                  disabled={isReadOnly}
                />
              </FormGroup>
              <FormGroup text="Total Target Cash" className="col-xs-4" labelClassName="form-control__label">
                <Dropdown
                  dropdownItems={FULL_MARKET_TARGET_OPTIONS}
                  text={targetTotalTargetCash}
                  btnClass="btn-default"
                  className="save-pricing__dropdown"
                  dropdownClass="save-pricing__dropdown-items"
                  itemOnClick={actions.setTargetTotalTargetCash}
                  disabled={isReadOnly}
                />
              </FormGroup>
            </div>
            <div className="row">
              <FormGroup text="Total Direct" className="col-xs-4" labelClassName="form-control__label">
                <Dropdown
                  dropdownItems={FULL_MARKET_TARGET_OPTIONS}
                  text={targetTotalDirect}
                  btnClass="btn-default"
                  className="save-pricing__dropdown"
                  dropdownClass="save-pricing__dropdown-items"
                  itemOnClick={actions.setTargetTotalDirect}
                  disabled={isReadOnly}
                />
              </FormGroup>
              <FormGroup text="Total Guaranteed Pay" className="col-xs-4" labelClassName="form-control__label">
                <Dropdown
                  dropdownItems={BASE_MARKET_TARGET_OPTIONS}
                  text={targetTotalGuaranteedPay}
                  btnClass="btn-default"
                  className="save-pricing__dropdown"
                  dropdownClass="save-pricing__dropdown-items"
                  itemOnClick={actions.setTargetTotalGuaranteedPay}
                  disabled={isReadOnly}
                />
              </FormGroup>
            </div>
          </div>
        </div>
      </ActionableHeaderCard>
    );
  }

  renderUserDefinedFields() {
    const {
      isUserDefinedFieldsLoading,
      userDefinedFields,
      slideout,
      selectedUserDefinedFields,
      isInitialized,
      isReadOnly
    } = this.props;

    if (isReadOnly && selectedUserDefinedFields.length === 0) {
      return null;
    }

    return (
      <ActionableHeaderCard cardTitle="User Defined Fields" className="save-job-pricing__card" isCollapsible={true}>
        <div className="row">
          <div className="col-md-6">
            {slideout.open && isInitialized && (
              <SelectableInput
                size="md"
                options={userDefinedFields}
                getOptionLabel={option => option.col_title}
                getOptionValue={option => option.col_name}
                getOptionType={this.getOptionType}
                placeholder="Select a User Defined Field..."
                instanceId="user-defined-fields-select"
                isDisabled={isUserDefinedFieldsLoading || isReadOnly}
                labelClassName="form-control__label"
                onChange={this.handleSelectableInputOnChange}
                selectedOptions={cloneDeep(selectedUserDefinedFields)}
              />
            )}
          </div>
        </div>
      </ActionableHeaderCard>
    );
  }

  getOptionType(option) {
    if (option.col_type === 'n' || option.col_type === 'm') {
      return INPUT_TYPE.NUMERIC;
    } else if (option.col_type === 'd') {
      return INPUT_TYPE.DATE;
    }
    return INPUT_TYPE.TEXT;
  }

  handleSelectableInputOnChange(option, selectedOptions) {
    const { actions, selectedUserDefinedFields } = this.props;
    const userDefinedFields = cloneDeep(selectedOptions);

    // figure out which fields were removed and set its value to null
    selectedUserDefinedFields.forEach(field => {
      const found = selectedOptions.find(option => option.col_name === field.col_name);
      if (!found) {
        field.inputValue = null;
        userDefinedFields.push(field);
      }
    });
    actions.setSelectedUserDefinedFields(userDefinedFields);
  }

  getFormGroupLabelForRequiredField(labelText) {
    return (
      <label className="form-control__label pxl-control-label">
        {labelText} <span className="required">*</span>
      </label>
    );
  }

  findRecommendedGrade() {
    const { structures } = this.props;
    const compositePricingData = this.extractCompositePricingData();
    const { selectedStructure } = this.state;
    
    this.setState({ recommendedGrade: null, recommendedGradeInfo: null });
    
    if (!compositePricingData || !compositePricingData.baseSalary50th || !selectedStructure) {
      return;
    }
    
    const structure = structures.find(s => s.value === selectedStructure.value);
    if (!structure || !structure.ranges || structure.ranges.length === 0) {
      return;
    }
    
    const baseSalary50th = compositePricingData.baseSalary50th;
    
    let bestGrade = null;
    let bestGradeInfo = null;
    let bestFitScore = Number.MAX_VALUE;
    
    structure.ranges.forEach(grade => {

      if (!grade.salaryMinimum || !grade.salaryMidpoint || !grade.salaryMaximum) {
        return;
      }
      
      // Calculate how well the salary fits in this grade
      // 0 = perfect fit (exactly at midpoint)
      // Negative = below midpoint
      // Positive = above midpoint
      const midpointDiff = Math.abs(baseSalary50th - grade.salaryMidpoint);
      const rangeSize = grade.salaryMaximum - grade.salaryMinimum;
      
      if (baseSalary50th >= grade.salaryMinimum && baseSalary50th <= grade.salaryMaximum) {
        // Calculate fit as percentage of range
        const fitScore = midpointDiff / (rangeSize / 2);
        
        if (fitScore < bestFitScore) {
          bestFitScore = fitScore;
          bestGrade = grade;
          bestGradeInfo = {
            structure: selectedStructure.value,
            grade: grade.grade,
            min: grade.salaryMinimum,
            mid: grade.salaryMidpoint,
            max: grade.salaryMaximum,
            baseSalary50th,
            percentOfRange: ((baseSalary50th - grade.salaryMinimum) / rangeSize) * 100,
            percentFromMidpoint: ((baseSalary50th - grade.salaryMidpoint) / (grade.salaryMidpoint)) * 100
          };
        }
      }
    });
    
    // If no grade contains the salary, find the closest one
    if (!bestGrade) {
      structure.ranges.forEach(grade => {

        if (!grade.salaryMinimum || !grade.salaryMidpoint || !grade.salaryMaximum) {
          return;
        }
        
        let distance;
        if (baseSalary50th < grade.salaryMinimum) {
          distance = grade.salaryMinimum - baseSalary50th;
        } else {
          distance = baseSalary50th - grade.salaryMaximum;
        }
        
        if (distance < bestFitScore) {
          bestFitScore = distance;
          bestGrade = grade;
          bestGradeInfo = {
            structure: selectedStructure.value,
            grade: grade.grade,
            min: grade.salaryMinimum,
            mid: grade.salaryMidpoint,
            max: grade.salaryMaximum,
            baseSalary50th,
            isOutOfRange: true,
            percentFromMidpoint: ((baseSalary50th - grade.salaryMidpoint) / (grade.salaryMidpoint)) * 100
          };
        }
      });
    }
    
    if (bestGrade) {
      this.setState({
        recommendedGrade: bestGrade,
        recommendedGradeInfo: bestGradeInfo
      });
    }
  }

  extractCompositePricingData() {
    const { jobPricingGrid, defaultCurrency, displayIn } = this.props;

    if (!jobPricingGrid?.summaryData?.length || displayIn !== 'annual') {
      return;
    }
    
    const baseSalary50thIndex = getColumnIndex(jobPricingGrid, 'base_salary_50th');
    const baseSalary25thIndex = getColumnIndex(jobPricingGrid, 'base_salary_25th');
    const baseSalary75thIndex = getColumnIndex(jobPricingGrid, 'base_salary_75th');
    const baseSalaryAvgIndex = getColumnIndex(jobPricingGrid, 'base_salary_avg');
    
    if (baseSalary50thIndex !== -1) {
      const compositePricingData = {
        baseSalary50th: jobPricingGrid.summaryData[0][baseSalary50thIndex],
        baseSalary25th: baseSalary25thIndex !== -1 ? jobPricingGrid.summaryData[0][baseSalary25thIndex] : null,
        baseSalary75th: baseSalary75thIndex !== -1 ? jobPricingGrid.summaryData[0][baseSalary75thIndex] : null,
        baseSalaryAvg: baseSalaryAvgIndex !== -1 ? jobPricingGrid.summaryData[0][baseSalaryAvgIndex] : null,
        currency: defaultCurrency
      };
      
      return compositePricingData;
    } else {
      console.warn('baseSalary50thIndex not found in composite pricing data');
    }
  }
}

const mapStateToProps = ({
  currency,
  saveJobPricing,
  jobFamilies,
  careerLevels,
  session,
  orgJobs,
  skillsByJobList,
  jobCertifications,
  slideout,
  marketPricing
}) => {  
  return {
    ...saveJobPricing,
    structures: selectStructures(saveJobPricing),
    jobStructure: selectJobStructure(saveJobPricing),
    jobPricingGrid: marketPricing.JobPricingReducer.JobPricingGridReducer,
    pricingDataLoading: marketPricing.JobPricingReducer.MainJobPricingReducer?.isLoading,
    currencies: currency.currencies,
    organization: session.organization,
    replacementTokens: session.replacementTokens,
    isReadOnly: session.user.rights.readOnlyUser,
    currenciesLoaded: currency.currenciesLoaded,
    isJobFamiliesLoading: jobFamilies.loading,
    isJobFamiliesLoaded: jobFamilies.loaded,
    jobFamilies: jobFamilies.items,
    careerLevels: careerLevels.items,
    isCareerLevelsLoading: careerLevels.loading,
    isCareerLevelsLoaded: careerLevels.loaded,
    userDefinedFields: orgJobs.userDefinedFields,
    isUserDefinedFieldsLoading: orgJobs.isUserDefinedFieldsLoading,
    isUserDefinedFieldsLoaded: orgJobs.isUserDefinedFieldsLoaded,
    skillsByJobList,
    jobCertifications,
    slideout,
    uniqueSalaryRange: session.uniqueSalaryRange,
    hasErrorRetrievingFields:
      saveJobPricing.hasSalaryRangesError ||
      jobFamilies.error ||
      careerLevels.error ||
      currency.currenciesError ||
      orgJobs.hasGetUserDefinedFieldsError
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...saveJobPricingActionCreators,
      hideSlideout,
      showSlideout,
      getJobFamilies,
      addJobFamilyOption,
      getCareerLevels,
      addCareerLevelOption,
      getJobUserDefinedFields,
      getJobSkills,
      skillsSearch,
      getJobCerts,
      certificationsSearch,
      setSelectedJobId,
      resetSkillsByJobListReducer,
      resetJobCertificationsReducer,
      getJobPricingDetails
    },
    dispatch
  ),
  jobPricingGridActions: bindActionCreators(
    {
      ...jobPricingGridActions
    },
    dispatch
  )
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withRouter(SaveJobPricingContainer)));
